import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../theme/ThemeProvider';
import { Lock } from 'lucide-react';
import FallingStarLogo from '../theme/FallingStarLogo';
import Navbar from '../components/Navbar';
import { ScaleIn } from '../components/ScrollReveal';

export default function RegisterPage() {
  const { t, glassCard } = useTheme();

  return (
    <>
      <Navbar />
      <div style={{ minHeight: 'calc(100vh - 64px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, position: 'relative', zIndex: 1 }}>
        <ScaleIn><div style={{ ...glassCard, padding: 40, width: '100%', maxWidth: 420 }}>
          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
              <FallingStarLogo size={48} />
            </div>
            <h1 style={{ fontSize: 24, fontWeight: 800, marginBottom: 6 }}>Registration Closed</h1>
            <p style={{ fontSize: 13, color: t.textMuted, lineHeight: 1.6 }}>
              xceller. is currently invite-only.
            </p>
          </div>

          <div style={{
            display: 'flex', alignItems: 'center', gap: 12,
            background: 'rgba(251,191,36,0.08)',
            border: '1px solid rgba(251,191,36,0.15)',
            borderRadius: 12, padding: '16px 18px', marginBottom: 24,
          }}>
            <Lock size={18} color="#fbbf24" style={{ flexShrink: 0 }} />
            <div>
              <div style={{ fontSize: 13, fontWeight: 600, color: t.text, marginBottom: 4 }}>
                New registrations are paused
              </div>
              <div style={{ fontSize: 12, color: t.textMuted, lineHeight: 1.5 }}>
                If you need access, contact the admin directly to get an account created for you.
              </div>
            </div>
          </div>

          <p style={{ textAlign: 'center', fontSize: 13, color: t.textMuted }}>
            Already have an account? <Link to="/login" style={{ color: t.primaryText, fontWeight: 600 }}>Log in</Link>
          </p>
        </div></ScaleIn>
      </div>
    </>
  );
}
